import {TaskFrx} from '../beans/TaskFrx';
import { AuthService } from '../services/auth.service';
import {BlockUiService} from '../services/blockui.service';
import {TaskService} from '../services/task.service';
import {CasesComponent} from '../cases/cases.component';
import {DatePipe} from '@angular/common';
import {Component, OnInit, Host, ViewContainerRef, ViewChild, HostListener } from '@angular/core';
import { StorageService } from '../services/storage.service';

@Component({
  selector: 'app-show-zadachi',
  templateUrl: './show-zadachi.component.html',
  styleUrls: ['./show-zadachi.component.scss']
})
export class ShowZadachiComponent implements OnInit {

	@ViewChild('editCase') editCase;
	
  private currentUserColor = '#FFFFFF';

  constructor(private blockUi: BlockUiService,
    private vcRef: ViewContainerRef,
    private taskService: TaskService,
    private datePipe: DatePipe,
    private authService: AuthService,
    private storageService: StorageService) {
  }
  tasksList: Array<TaskFrx>;

  public colsTask = [
    {title: 'Насрочено за', name: 'deadlineString'},
    {title: 'Статус', name: 'statusTaskBG'},
    {title: 'Описание', name: 'opisanie'},
    {title: 'Отговорник', name: 'otgovornik', dataType: 'object', complexDataType: {object: true, displayValue: 'username'}}
  ];

  ngOnInit() {
    this.currentUserColor = this.storageService.getLoginResponse().color || '#FFFFFF';
    this.loadTasksList();
  }
  
  loadTasksList() {
    this.blockUi.start(this.vcRef);
    this.tasksList = new Array<TaskFrx>();
    this.taskService.getTasksByUser().subscribe(lst => {
      this.tasksList = lst;
      for (let i = 0; i < this.tasksList.length; i++) {
        this.tasksList[i].deadlineString = this.datePipe.transform(this.tasksList[i].deadline, 'dd.MM.yyyy');
        let statusTaskBG = '';
        switch (this.tasksList[i].statusTask) {
          case 'NOVA': {
            statusTaskBG = 'НОВА';
            break;
          }
          case 'V_PROCESS': {
            statusTaskBG = 'В ПРОГРЕС';
            break;
          }
          case 'IZPULNEN': {
            statusTaskBG = 'ИЗПЪЛНЕНА';
            break;
          }
        };
        let daysForWarning = 10 * (1000 * 60 * 60 * 24);
        if (new Date(this.tasksList[i].deadline).getTime()  - daysForWarning <= (new Date()).getTime() && this.tasksList[i].statusTask != 'IZPULNEN') {
          this.tasksList[i].isWarning = true;
        }
        this.tasksList[i].color = this.tasksList[i].otgovornik.color || this.currentUserColor;
        this.tasksList[i].statusTaskBG = statusTaskBG;
      }
      this.blockUi.stop();
    },
      error => {
        this.blockUi.stop();
      });
  }
  
  upgradeTask(task) {
    if (!confirm('Сигурни ли сте че искате да промените статуса на тази задача!')) {
      return;
    }
    this.blockUi.start(this.vcRef);
    this.taskService.changeStatus(task.id, true).subscribe(
      result => {
        alert('Статуса беше променен успешно!');
        this.loadTasksList();
        this.blockUi.stop();
      },
      error => {
        alert('Изникна грешка с промяната на статуса!');
        this.blockUi.stop();
      });
  }

  downgradeTask(task) {
    if (!confirm('Сигурни ли сте че искате да промените статуса на тази задача!')) {
      return;
    }
    this.blockUi.start(this.vcRef);
    this.taskService.changeStatus(task.id, false).subscribe(
      result => {
        alert('Статуса беше променен успешно!');
        this.loadTasksList();
        this.blockUi.stop();
      },
      error => {
        alert('Изникна грешка с промяната на статуса!');
        this.blockUi.stop();
      });
  }
  
  editCaseFromTask(row){
  		this.editCase.editCaseFromTask(row);
  }
  
  @HostListener('document:keydown', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {

		// 👉 Ctrl + Enter -> Търси
		if (event.ctrlKey && event.key === 'Enter') {
			event.preventDefault();
			this.loadTasksList();        // твоя метод за търсене
		}
	}
}
